export default "__VITE_ASSET__CcNJN7Yz__"